(() => {
  const q = (s, r=document) => r.querySelector(s);
  const qa = (s, r=document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Boot.
  const boot = q("[data-boot]");
  if (boot) {
    const seen = sessionStorage.getItem("code_boot_seen");
    if (seen || reduce) boot.classList.add("done");
    else {
      let p=0;
      const statuses=["INITIALIZING","LOADING OBJECTS","CALIBRATING SYSTEM","SYSTEM READY"];
      const timer=setInterval(()=>{
        p=Math.min(100,p+Math.random()*14+7);
        q("[data-boot-bar]").style.width=p+"%";
        q("[data-boot-percent]").textContent=String(Math.round(p)).padStart(3,"0")+"%";
        q("[data-boot-status]").textContent=statuses[Math.min(3,Math.floor(p/27))];
        if(p>=100){clearInterval(timer);sessionStorage.setItem("code_boot_seen","1");setTimeout(()=>boot.classList.add("done"),450)}
      },100);
    }
  }

  // Cursor.
  const cursor=q("[data-code-cursor]");
  if(cursor && !reduce && innerWidth>800){
    const label=q("span",cursor); let x=0,y=0,tx=0,ty=0;
    addEventListener("mousemove",e=>{tx=e.clientX;ty=e.clientY;cursor.classList.add("is-on")},{passive:true});
    addEventListener("mouseout",()=>cursor.classList.remove("is-on"));
    const loop=()=>{x+=(tx-x)*.16;y+=(ty-y)*.16;cursor.style.left=x+"px";cursor.style.top=y+"px";requestAnimationFrame(loop)};loop();
    qa("[data-cursor],a,.code-object").forEach(el=>{
      el.addEventListener("mouseenter",()=>label.textContent=el.dataset.cursor||"VIEW");
      el.addEventListener("mouseleave",()=>label.textContent="MOVE");
    });
  }

  // Magnetic buttons.
  if(!reduce) qa("[data-magnetic]").forEach(el=>{
    el.addEventListener("mousemove",e=>{const r=el.getBoundingClientRect();el.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.1}px,${(e.clientY-r.top-r.height/2)*.1}px)`});
    el.addEventListener("mouseleave",()=>el.style.transform="");
  });

  // Hero parallax.
  const hero=q("[data-hero]"), media=q(".code-hero__media"), copy=q("[data-parallax]");
  if(hero && !reduce){
    addEventListener("scroll",()=>{
      const r=hero.getBoundingClientRect(), p=Math.max(0,Math.min(1,-r.top/r.height));
      if(media) media.style.transform=`scale(${1.02+p*.05}) translate3d(0,${p*-3}%,0)`;
      if(copy) copy.style.transform=`translate3d(0,${p*-80}px,0)`;
    },{passive:true});
  }

  // Scrub giant 001.
  const scrub=q("[data-scrub]");
  if(scrub && !reduce) addEventListener("scroll",()=>{
    const r=scrub.parentElement.getBoundingClientRect();
    const p=Math.max(-1,Math.min(1,(innerHeight-r.top)/innerHeight-.5));
    scrub.style.transform=`translate3d(${p*10}vw,${p*-3}vw,0) rotate(${p*2}deg)`;
  },{passive:true});

  // Secret CODE mode: type CODE.
  let typed="";
  addEventListener("keydown",e=>{
    if(e.key.length===1){
      typed=(typed+e.key.toUpperCase()).slice(-4);
      if(typed==="CODE"){
        document.body.classList.toggle("code-secret");
        typed="";
      }
    }
  });

  // Smooth in-page anchors without hijacking checkout/external navigation.
  qa('a[href^="#"]').forEach(a=>a.addEventListener("click",e=>{
    const target=q(a.getAttribute("href")); if(target){e.preventDefault();target.scrollIntoView({behavior:reduce?"auto":"smooth"})}
  }));
})();